module.exports = __webpack_public_path__ + "static/img/js2.fb1a53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/js2.png
// module id = Akyz
// module chunks = 1